import { Component } from 'react';
import DataTable from 'Container/DataTable/DataTableContainer';
import Pagination from '../../Components/Pagination';
import Image from '../Common/Image';
import formUrlParams from 'Helpers/urlform';
import { debounce } from 'lodash';
import EditButton from 'Components/Table/EditButton';
import DeleteButton from 'Components/Table/DeleteButton';
import ReplyHelp from 'Container/Help/ReplyHelpContainer';
import { ReactComponent as Android } from 'assets/images/svg/android.svg';
import { ReactComponent as Ios } from 'assets/images/svg/apple.svg';
import { CSVLink } from 'react-csv';
import { ReactComponent as Close } from 'assets/images/svg/Popclose.svg';
import { toast as toastr } from 'react-toastify';
import { ModuleActions } from 'Constants/Modules.constants';

class Help extends Component {

  constructor(props) {
    super(props);
    const model = {
      headers: [
        {
          title: 'First Name',
          accessor: 'firstName',
          chooseOption: {
            name: 'firstNameSearch',
            Component: 'Search',
            dispatchFunction: this.handleSearch,
          },
          sortOption: true,
        },
        {
          title: 'Last Name',
          accessor: 'lastName',
          chooseOption: {
            name: 'lastNameSearch',
            Component: 'Search',
            dispatchFunction: this.handleSearch,
          },
          sortOption: true,
        },
        {
          title: 'Email',
          accessor: 'email',
          chooseOption: {
            name: 'emailSearch',
            Component: 'Search',
            dispatchFunction: this.handleSearch,
          },
          sortOption: true,
        },
        {
          title: 'Device Platform',
          accessor: 'devicePlatform',
          chooseOption: {
            name: 'devicePlatformSearch',
            Component: 'DropDown',
            dispatchFunction: this.handleSearch,
            optionRender: this.createDevicePlatform,
            DropdownText:'All'
          },
          cell: function(rowDetails) {
            const { content, index } = rowDetails;
            const deviceType =
              content !== '' ? (
                content === 'android' ? (
                  <>
                    <i className='android'>
                      <Android />
                    </i>
                    {content}
                  </>
                ) : (content === 'ios' || content === 'iOS') ? (
                  <>
                    <i className='android'>
                      <Ios />
                    </i>
                    {content}
                  </>
                ) : (
                  ''
                )
              ) : (
                ''
              );
            return <td key={ index }>{deviceType}</td>;
          }
        },
        {
          title: 'Device Model',
          accessor: 'deviceModel',
          chooseOption: {
            name: 'deviceModelSearch',
            Component: 'Search',
            dispatchFunction: this.handleSearch,
          },
          sortOption: true,
        },
        {
          title: 'App Version',
          accessor: 'appVersion',
          chooseOption: {
            name: 'appVersionSearch',
            Component: 'Search',
            dispatchFunction: this.handleSearch,
          },
          sortOption: true,
        },
        {
          title: 'Message',
          accessor: 'description',
          chooseOption: {
            name: 'descriptionSearch',
            Component: 'Search',
            dispatchFunction: this.handleSearch,
          },
          sortOption: true,
        },
        {
          title: 'Image',
          accessor: 'image',
          combineapidata: [ '', 'image' ],
          cell: (rowDetails)=>{
            const { index, content, ...rest } = rowDetails;
            return(
            <td key={ index }>
               <div className='user 111'>
                  { rest.image ? <Image imageToken={ rest.image } /> : 'N/A' }
                </div>
            </td>
            )            
          },
        },
        /* {
          title: 'Status',
          accessor: 'status',
          chooseOption: {
            name: 'statusSort',
            Component: 'DropDown',
            DropdownText: 'All',
            dispatchFunction: this.handleSearch,
            optionRender: this.createStatus,
          },
          cell: function (rowDetail) {
            const { content, index } = rowDetail;
            const status =
              content === 1 ? (
                <Fragment>
                  <span className='active'></span>Enable
                </Fragment>
              ) : (
                <Fragment>
                  <span className='inactive'></span>Disable
                </Fragment>
              );
            return <td key={ index }>{status}</td>;
          },
          //sortOption: true,
        }, */
        {
          title: 'Action',
          accessor: 'id',
          cell: (rowDetail) => {
            const { index, id, rowIdx, isRead, profile, ...rest } = rowDetail;
            const permission = profile && profile.help;
            return (
              <td key={ index } data-row={ rowIdx } className='action'>
                { permission && !permission[ ModuleActions.edit ] && !permission[ ModuleActions.delete ] && 'N/A' }
                { permission && permission[ ModuleActions.edit ] && !isRead && <EditButton
                  id={ id }
                  { ...rowDetail }
                  getActiveEditData={ this.getActiveEditData }
                  editClass='editDomain'
                  checkPermission={ permission && permission[ ModuleActions.edit ] }
                />}
                { permission && permission[ ModuleActions.delete ] && <DeleteButton
                  remainningRecords={ this.props.help.length }
                  deleteActionListener={ this.props.deleteHelp }
                  activeQuery={ this.state.filtered }
                  id={ id }
                  currentPage={ this.props.currentPage }
                  checkPermission={ permission && permission[ ModuleActions.delete ] }
                  deletePopupStatus={ this.deletePopupStatus }
                />}
              </td>
            );
          },
        },
      ],
      filtered: [ { id: 'isFeedback', value: false } ],
      responseArray: [],
      pageLimit: 10,
      permission: true,
      activeSort: {},
      saveHelpFormStatus: false,
      viewPhoto: false,
      feedbackImage: null,
      activeEditData: '',
      deletePopup: false,
    }
    this.state = model;
  }

  componentDidMount() {
    const { filtered } = this.state;
    this.props.fetchHelp(filtered);
    this.props.exportHelp(filtered);
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevState.deletePopup !== this.state.deletePopup) {
      this.setState({ saveHelpFormStatus: false }, () => {
        this.setState({ activeEditData: '' });
      });
    }
  }

  getActiveEditData = (data) => {
    if(data.isRead) return;
    const { profile } = this.props;
    const { edit } = profile.help || {};
    if(!edit) {
      toastr.dismiss();
      toastr.error('You dont have permission to edit');
      return;
    }
    this.setState({ saveHelpFormStatus: true }, () => {
      if(data !== '') this.setState({ activeEditData: data });
    });
  };

  deletePopupStatus = (status) => {
    this.setState({
      deletePopup: status
    })
  }
  
  handleViewPhoto = (image) => {
    this.setState({ saveHelpFormStatus: false, feedbackImage: image, viewPhoto: !this.state.viewPhoto });
  };

  setPageLimit = ( name, value ) => {
    this.formUrlParams(name, value, { pageLimit: value })
  }

  formUrlParams = (name, value, rest) => {
    const { filtered, activeSort } = this.state;
    const filterResponse = formUrlParams(filtered, name, value);
    this.setState({ filtered: filterResponse, ...rest }, () => {
      let updatedFilter = this.state.filtered;
      if(activeSort && activeSort.id){
        updatedFilter = [
          ...this.state.filtered,
          activeSort
        ]
      }
      this.props.fetchHelp(updatedFilter);
    });
  }

  /**
   * @method closeForm
   * @summary close save domain popup
   * @return { object } updated domain state
   */

  closeForm = () => {
    this.setState({ saveHelpFormStatus: false, filtered: [] });
  };

  /**
   * @method debounceEvent
   * @summary used to delay the event for some limit
   * @param {event} event - React onChange event
   * @return { function } debouncedEvent
   */
  debounceEvent(...args) {
    this.debouncedEvent = debounce(...args);
    return (e) => {
      e.persist();
      return this.debouncedEvent(e);
    };
  }  

  sortTable = (sortAttribite) => {
    const { activeSort } = this.state
    const sortType = (activeSort.id === sortAttribite) ? 
    ((activeSort.value && activeSort.value == 'desc') ? 'asc' : 'desc') : 'asc';
    this.setState({
      activeSort: { id: sortAttribite, value: sortType },
    }, () => {
      this.formUrlSort();
    })
  }

  formUrlSort = () => {
    const updatedFilter = [
      ...this.state.filtered,
      this.state.activeSort
    ]
    this.props.fetchHelp(updatedFilter);
  }

  createStatus = () => {
    const statusArray = [ 'Disable', 'Enable' ]
    return statusArray.map((type, index) => {
      return (
          <option key={ index } value={ index }>{type}</option>
      )
    })
  }

  handleSearch = event => {
    const { name, value } = event.target;
    this.formUrlParams(name, value);
  }

  createDevicePlatform = () => {
    const deviceArray = [ 'Android', 'Ios' ]
    return deviceArray.map((type, index) => {
        return (
            <option key={ index } value={ type.toLowerCase() }>{ type }</option>
            
        )
    })
  }

  updateActiveQuery = (updatedpagination) => {
    this.setState({
      filtered: [ ...this.state.filtered, ...updatedpagination ],
    });
  };

  render() {
    const { help, loading, totalRecords, currentPage, exportHelpData } = this.props;
    const { saveHelpFormStatus, viewPhoto, feedbackImage, activeEditData } = this.state;
    return (
      <>
        <div className='grid pageContainer_inner'>
          <div className='heading-block gap-10'>
            <h4>Manage Help</h4>
            { exportHelpData && exportHelpData.length !== 0 && <CSVLink
                  data = { exportHelpData }
                  filename = { 'Help Details.csv' }
                  className = 'btn btn_green'
                  onClick={ () => {
                    console.log('Export Data'); // Your click handling logic
                  } }
                >
                  Export To CSV
                </CSVLink>
            }
          </div>
          {saveHelpFormStatus && !viewPhoto && (
              <ReplyHelp
                closeForm={ this.closeForm }
                filterVal={ this.state.filtered }
                activeEditData = { activeEditData }
              />
            )}
            {viewPhoto && (
              <div className='profile-container viwe-profileImage'>
                <div className='profile-popup-visible'>
                <button className='close-btn' onClick={ () => this.handleViewPhoto() }>
                  <Close />
                </button>
                  <div className='popup-controls'>
                    <div>
                      <Image
                        className='viewImage'
                        name='profileImage'
                        alt='Profile Image'
                        imageToken={ feedbackImage }
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          <div className='responsive-table ctTableBox'>
            <DataTable
              headers={ this.state.headers }
              data={ help }
              noData='No records!'
              loading={ loading }
              sortTable = { this.sortTable }
              className = { `clickable-tr` }
              clickableTR = { [ { dispachFunction: this.getActiveEditData, parameter: '' } ] }
            />
            <Pagination
              handleClick={ this.formUrlParams }
              totalRecords={ totalRecords }
              initialPage={ currentPage }
              setPageLimit={ this.setPageLimit }
              pageLimit={ this.state.pageLimit }
              updateActiveQuery={ this.updateActiveQuery }
            />
          </div>
        </div>
      </>
    );
  }
}
export default Help;
